import { z } from 'zod';

export const AI_FILTER_TARGETS = ['tasks', 'posts'] as const;

export const aiFilterTargetSchema = z.enum(AI_FILTER_TARGETS);

export type AiFilterTarget = z.infer<typeof aiFilterTargetSchema>;

export const aiFilterValueSchema = z.object({
  filterType: z.string(),
  value: z.union([z.string(), z.array(z.string())]),
});

export type AiFilterValue = z.infer<typeof aiFilterValueSchema>;

export const parseNaturalLanguageFilterRequestSchema = z.object({
  target: aiFilterTargetSchema,
  query: z.string().trim().min(1).max(300),
});

export type ParseNaturalLanguageFilterRequest = z.infer<
  typeof parseNaturalLanguageFilterRequestSchema
>;

export const parseNaturalLanguageFilterResponseSchema = z.object({
  filterValues: z.array(aiFilterValueSchema),
  // Names/terms from the query that couldn't be matched to a known teammate,
  // client, status, platform, or date range — surfaced to the user as a hint.
  unresolved: z.array(z.string()),
});

export type ParseNaturalLanguageFilterResponse = z.infer<
  typeof parseNaturalLanguageFilterResponseSchema
>;
